import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import clsx from "clsx";
import LanguageCurrencyChanger from "./sub-components/LanguageCurrencyChanger";
import { formatPrice } from "../../utils/FormatCurrency";
import { useTranslation } from "react-i18next";
const HeaderTop = ({ borderStyle }) => {
  const currency = useSelector((state) => state.currency);
  const { t } = useTranslation();
  return (
    <div
      className={clsx(
        "header-top-wap",
        borderStyle === "fluid-border" && "border-bottom"
      )}
    >
      <LanguageCurrencyChanger currency={currency} />
      {/* <div
        style={{
          backgroundColor: "darkred",
          color: "#FFFFFF",
          fontWeight: "600",
          fontSize: "14px",
          padding: "6px 12px",
          borderRadius: "9999px",
          display: "inline-block",
        }}
      >
        <p style={{ margin: 0, color: "inherit" }}>
          ⭐ {t("shop_more_earn_more")}
        </p>
      </div> */}
    </div>
  );
};

HeaderTop.propTypes = {
  borderStyle: PropTypes.string,
};

export default HeaderTop;
